import { render, staticRenderFns } from "./ScoringControlRecommendation.vue?vue&type=template&id=73eb06fe"
import script from "./ScoringControlRecommendation.vue?vue&type=script&lang=js"
export * from "./ScoringControlRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports